<template>
  <section id="about" class="about-section">
    <h2>Welcome to Dr. Mayo Lee's Psoriasis Treatment Center</h2>
    <div class="highlight-box">
      <p>Combining cutting-edge research with personalized care, we offer innovative solutions for psoriasis treatment. Our approach integrates traditional medical practices with the latest biological therapies to provide optimal results for our patients.</p>
    </div>
    <div class="grid-container">
      <div class="grid-item">
        <h3>Why Choose Us</h3>
        <ul>
          <li>20+ Years of Experience</li>
          <li>Board-Certified Dermatologist</li>
          <li>Innovative Treatment Methods</li>
          <li>Personalized Care Plans</li>
        </ul>
      </div>
      <div class="grid-item">
        <h3>Our Approach</h3>
        <ul>
          <li>Evidence-Based Treatment</li>
          <li>Advanced Biological Therapy</li>
          <li>Ongoing Research Programs</li>
          <li>Holistic Care Solutions</li>
        </ul>
      </div>
      <div class="grid-item">
        <h3>Quick Links</h3>
        <ul>
          <li>Schedule Appointment</li>
          <li>Patient Resources</li>
          <li>Treatment Options</li>
          <li>Research Publications</li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AboutSection'
}
</script>

<style scoped>
.about-section {
  padding: 60px 20px;
}

.highlight-box {
  background-color: #f8f9fa;
  padding: 30px;
  margin: 30px 0;
  border-radius: 8px;
  text-align: center;
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;
  margin-top: 40px;
}

.grid-item {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.grid-item h3 {
  color: #2c3e50;
  margin-bottom: 15px;
}

.grid-item ul {
  list-style-type: none;
  padding: 0;
}

.grid-item li {
  margin: 10px 0;
  padding-left: 20px;
  position: relative;
}

.grid-item li:before {
  content: "•";
  color: #42b983;
  position: absolute;
  left: 0;
}
</style>
